var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgRdatapBlue = function SvgRdatapBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "771.313 209.192 22.643 21.054"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M792.697 226.412l-15.573 3.774c-.958.236-1.677-.236-1.917-1.18l-3.833-15.332c-.24-.944.24-1.651 1.198-1.887l10.542-2.595c.48 0 .72 0 1.198.236l3.114 1.651 3.115 1.651c.48.236.72.472.72.944l2.634 10.85c.24.708-.239 1.652-1.198 1.888zm-14.614.236l12.458-2.831-2.156-8.492-2.396-1.415-2.396-1.18-8.386 1.652 2.876 12.266z",
    fill: "#96D7D6"
  })));
};
export default SvgRdatapBlue;